import * as model from '@qvs/core';
import { DatafeedNewsItemMobile } from '@wize-mobile-api';
import { NewsListResponse } from '@news-api';
import { DateUtils } from '~/shared/utils/date.utils';

export class NewsMapper {
  public static fromWizeNewsItems(newsItems: DatafeedNewsItemMobile[]): model.NewsItem[] {
    return newsItems.map((item) => {
      const pdfMedia = item.medias.find((media) => media.mimeType === 'application/pdf');
      return {
        id: item.id,
        date: DateUtils.new(item.publishedAt).toDate(),
        pdfMediaId: pdfMedia ? pdfMedia.id : null,
        text: item.description,
        title: item.title
      };
    });
  }

  public static fromCgeNewsItems(newsResponse: NewsListResponse): model.CgeNews {
    const totalItems = newsResponse.totalItems;
    const items = newsResponse.items.map((item) => ({
      id: item.id,
      title: item.title,
      category: item.category,
      categoryId: item.category_id,
      date: item.publishedAt,
      thumbnailUrl: item.thumbnail.url,
      link: item.link
    }));
    return {
      items,
      totalItems
    };
  }
}
